module.exports = __webpack_public_path__ + "img/Indonesia-05.876541c6.jpg";